import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import ColoredInImage from '../Images/ColoredInImage'; // Adjust path if necessary

function OrderCard({ order }) {
  if (!order) {
    return null; // Don't render if order data is missing
  }

  // Determine status display text and color (similar to AllImagesCard)
  let statusText = "Status: ";
  let statusColor = "text.secondary"; // Default color

  switch (order.status) {
    case "quote":
      statusText += "Quote Submitted";
      statusColor = "purple";
      break;
    case "pending":
      statusText += "Order Pending";
      statusColor = "darkgreen";
      break;
    case "completed":
      statusText += "Order Completed";
      statusColor = "green";
      break;
    case "cancelled":
      statusText += "Cancelled";
      statusColor = "red";
      break;
    default:
      statusText += order.status || "Unknown";
      statusColor = "grey";
  }

  return (
    <Card sx={{
      maxWidth: 550, // Max width for the card to accommodate the 500px image
      minWidth: 500, // Min width to ensure image fits
      margin: '15px',
      boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
      borderRadius: '12px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '15px'
    }}>
      <CardContent sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* Image Preview Section */}
        {order.user_image_preview ? (
          <Box sx={{
            width: '100%', // Take full width of card content
            minHeight: '300px', // Give some minimum height for the image
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f5f5f5', // Light background for image area
            borderRadius: '8px',
            overflow: 'hidden', // Hide overflow if image is too big
            marginBottom: '15px',
            border: '1px solid #e0e0e0'
          }}>
            <ColoredInImage
              component={order.user_image_preview.component}
              fillColors={order.user_image_preview.fill_colors}
              onFill={() => {}} // No fill functionality needed
              id={order.user_image_preview.id}
              size={'xl'} // Try 'xl' or adjust as needed for your component
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} // Ensure image scales within container
            />
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            No Image Preview Available
          </Typography>
        )}

        {/* Order Details Section */}
        <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold', color: '#333' }}>
          Order ID: {order.id}
        </Typography>
        <Typography variant="body2" color="text.primary" sx={{ mb: 0.5 }}>
          User ID: {order.user_id}
        </Typography>
        <Typography variant="body2" color="text.primary" sx={{ mb: 0.5 }}>
          User Email: {order.email}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <span style={{ color: statusColor, fontWeight: 'bold' }}>{statusText}</span>
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          Dimensions: {order.width} x {order.height} (Glass: {order.glass_width} x {order.glass_height})
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          Frame Type: {order.frame_type || 'N/A'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          Window Shape: {order.window_shape || 'N/A'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          Installation: {order.installation_options || 'N/A'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          Shipping Zip: {order.shipping_zip_code || 'N/A'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          {/* Safely display price, ensuring it's a number before calling toFixed */}
          Price: ${typeof order.price === 'number' ? order.price.toFixed(2) : 'N/A'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          Shipping Status: {order.shipping_status || 'N/A'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          Tracking Order: {order.tracking_order || 'N/A'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          Quote Requested: {order.quote_requested ? "Yes" : "No"}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          User Image ID: {order.user_image_id || 'N/A'}
        </Typography>
        {order.additional_notes && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontStyle: 'italic' }}>
            Notes: {order.additional_notes}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}

export default OrderCard;